// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, FacebookAuthProvider } from "firebase/auth";
import { getDatabase } from "firebase/database";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig: any = {
    apiKey: "AIzaSyD4kKh0jAJtGmFoCpr6DyEPjmpZGCQRpaE",
    authDomain: "hotels-4279e.firebaseapp.com",
    projectId: "hotels-4279e",
    storageBucket: "hotels-4279e.appspot.com",
    messagingSenderId: "781585966040",
    appId: "1:781585966040:web:5fc0b8a267e8e59c8cc8ad"
};

export const channel = 'conversation_chat-4hotels-com_';

// Initialize Firebase
const app: any = initializeApp(firebaseConfig);

export const auth: any = getAuth(app);
export const googleProvider: any = new GoogleAuthProvider();
export const fbProvider: any = new FacebookAuthProvider();
export const databaseChat = getDatabase(app);